import React, { useEffect, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label, { DisplayLabel } from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Float from "../ui/Float";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { bm_date, drawNote, drawPOSStatus } from "../utils/Utils";

export default function POSDetails(props) {

    const { selected = {}, setSelected = () => { }, items = [], setItems = () => { }, selectedItem = {}, setSelectedItem = () => { } } = props;
    const [data, setData] = useState({});

    useEffect(() => {
        console.log("called")
        if (!selected?.invoice) { return; }
        pubCall("point_of_sale.getSingle", { invoice: selected?.invoice }, (_s, _r) => {
            if (_s) {
                //setSelected({...selected, "calculated_totals" : _r.header.calculated_totals});

                setItems(_r?.items);
                setSelectedItem((_r.items.length > 0) ? _r.items[0] : {})
                setData(_r);
            } else {
                showError(_r);
            }
        })

    }, [selected?.invoice])


    const drawBill = () => {
        const c = data?.header?.customer_bill_to || {};
        const {
            name = "",
            account_number = "",
        } = c;
        return (
            <>
                <Space size={10}>
                    <Label width={35}>Bill</Label><DisplayLabel style={{ "textAlign": "left" }} width={510}>{name}&nbsp;</DisplayLabel>
                    <Label width={40}>Acct#</Label><DisplayLabel width={95}>&nbsp;{account_number}</DisplayLabel>
                </Space>
                <Space><Label width={42}></Label><Divider /></Space>
            </>
        )
    }


    const drawShip = () => {

        const c = data?.header?.customer_ship_to || {};

        const {
            name = "",
            address_1 = "",
            address_2 = "",
            city = "",
            province = "",
            postal_code = "",
            country = "",
        } = c;

        return (
            <>
                <div style={{ "height": "66px" }}><Space style={{ "alignItems": "start" }} size={10}>
                    <Label width={35}>Ship</Label><DisplayLabel className="text-yellow" style={{ "textAlign": "left" }} width={455}>
                        <div>{name}</div>
                        <div>{address_1} {address_2}</div>
                        <div>{(city && <>{city}, </>)}{province} {postal_code} {country}</div>
                    </DisplayLabel>
                    <Space>
                        <Label width={25}>A/R</Label>
                        <Input medium style={{ "backgroundColor": "#E74856" }} width={135} value={<Float><small>Credit</small><div>?</div></Float>} />

                    </Space>
                </Space>
                </div>
                <Space><Label width={42}></Label><Divider /></Space>
            </>
        )
    }

    const drawVia = () => {
        const c = data?.header || {};
        const {
            ship_via = "",
            terms = ""
        } = c;

        return (
            <>
                <Float><Label>Via</Label><DisplayLabel className={"text-yellow"} >&nbsp;{ship_via}</DisplayLabel></Float>
                <Float><Label>Terms</Label><DisplayLabel >&nbsp;{terms}</DisplayLabel></Float>
                <Float><Label>&nbsp;</Label><DisplayLabel >&nbsp;</DisplayLabel></Float>
                <Float><Label>&nbsp;</Label><DisplayLabel >&nbsp;</DisplayLabel></Float>
            </>
        )
    }


    const drawTaxes = (_taxes = [], inc) => {

        if (_taxes.length >= inc) {

            const {
                amount = 0,
                item_amount = 0,
                name = "",
                code = "",
                rate = 0,
            } = _taxes[inc - 1];

            return (<Float><Label>{code} {name}</Label><DisplayLabel >{amount}</DisplayLabel></Float>)
        } else {
            return (<Float><Label>&nbsp;</Label><DisplayLabel >&nbsp;</DisplayLabel></Float>)
        }

    }
    const drawCalculatedTotals = () => {

        const c = data?.header?.calculated_totals || {};
        const {
            sub_total = 0,
            item_total = 0,
            tax_total = 0,
            total = 0,
            taxes = []
        } = c;
        const items = data?.items || [];

        return (
            <>
                <div style={{ "height": "5px" }} />
                <Float><Label>&nbsp;</Label><Label >{(items.length && <>{items.length + " items"}</>)}</Label></Float>
                <Float><Label>Sub</Label><DisplayLabel >{sub_total}</DisplayLabel></Float>
                {drawTaxes(taxes, 1)}
                {drawTaxes(taxes, 2)}
                {drawTaxes(taxes, 3)}
                <div style={{ "height": "9px" }} />
                <Input warning width={172} value={<Float><small>Total</small><div>{total}</div></Float>} />
            </>
        )

    }


    const drawImage = () => {
        return (<div className="img-contain" style={{ "maxWidth": "200px", "maxHeight": "250px", "marginTop": "10px", "backgroundImage": "url('https://bookmanager.com/i/bkmngr_cover/isbn/" + "9780593230381" + "')" }}></div>)
    }


    const drawAccount = () => {
        const c = data?.header?.customer_bill_to || {};
        const {
            name = "",
            address_1 = "",
            address_2 = "",
            city = "",
            province = "",
            postal_code = "",
            country = "",
            email = "",
            account_number = "",
            communication_preference = "",
            tax_group_code = "",
        } = c;

        return (
            <div>
                <div style={{ "height": "88px" }}>
                    <Space style={{ "alignItems": "start" }} size={10}>
                        <Label width={35}>Acct</Label><DisplayLabel style={{ "textAlign": "left" }} width={510}>
                            <div>{name}</div>
                            <div>{address_1} {address_2}</div>
                            <div>{(city && <>{city}, </>)}{province} {postal_code} {country}</div>
                            <div>{email}</div>
                        </DisplayLabel>
                        <div>
                            <Space><Label style={{ "textAlign": "left" }} width={40}>Acct#</Label><DisplayLabel width={95}>{account_number}&nbsp;</DisplayLabel></Space>
                            <Space><Label style={{ "textAlign": "left" }} width={90}>Contact Pref</Label><DisplayLabel className="text-yellow" width={45}>{communication_preference}&nbsp;</DisplayLabel></Space>
                            <Space><Label style={{ "textAlign": "left" }} width={90}>Tax Code</Label><DisplayLabel width={45}>{tax_group_code}&nbsp;</DisplayLabel></Space>
                        </div>
                    </Space>
                </div>
                <Space><Label width={42}></Label><Divider /></Space>
            </div>
        )
    }

    const drawPO = () => {

        const c = data?.header || {};
        const {
            purchase_order = ""
        } = c;

        return (
            <Space style={{ "alignItems": "start" }} size={10}>
                <Label width={35}>PO#</Label><DisplayLabel style={{ "textAlign": "left" }} width={455}>{purchase_order} &nbsp;</DisplayLabel>
                <Space><Label width={35}>A/R</Label>
                    <Input style={{ "backgroundColor": "#E74856" }} width={135} value={<Float><small>Credit</small><div>?</div></Float>} />
                </Space>
            </Space>
        )

    }

    const drawNote = () => {
        const note = data?.header?.notes || "";
        return (
            <Space size={10}>
                <Label width={35}>Note</Label><DisplayLabel><em>{note} &nbsp;</em></DisplayLabel>
            </Space>
        )
    }


    const drawGroup = () => {

        const c = data?.header || {};
        const {
            date = "",
            invoice = "",
            points_total = 0,
            points_earned = 0,
            group = "",
            clerk_code = "",
        } = c;
        return (
            <>
                <Float>
                    <div><Space><Label>Group</Label><DisplayLabel>{group}&nbsp;</DisplayLabel></Space></div>
                    <div><Space><Label>Clerk</Label><DisplayLabel>{clerk_code}&nbsp;</DisplayLabel></Space></div>
                </Float>
                <Float><Label>Date</Label><DisplayLabel >{bm_date(date / 1000)}&nbsp;</DisplayLabel></Float>
                <Float><Label>Time</Label><DisplayLabel >?&nbsp;</DisplayLabel></Float>
                <Float><Label>Inv#</Label><DisplayLabel >{invoice}&nbsp;</DisplayLabel></Float>
                <Float><Label>Status</Label><DisplayLabel >{drawPOSStatus(invoice)}&nbsp;</DisplayLabel></Float>
                <div style={{ "height": "60px" }} />
                <Float><Label>Profit Margin</Label><DisplayLabel>?&nbsp;</DisplayLabel></Float>
                <Float><Label>Points Total</Label><Input right width={65} medium style={{ "backgroundColor": "#E74856" }} value={points_total} /></Float>
                <Float><Label>Points Earn</Label><DisplayLabel >{points_earned}&nbsp;</DisplayLabel></Float>
            </>
        )

    }

    return (
        <div className="pos-card">

            <div style={{ flex: 1, display: 'flex', flexDirection: 'row', gap: "20px" }}>
                <div style={{ flex: "1 1 500px", minWidth: "200px" }}>
                    {drawBill()}
                    {drawShip()}
                    {drawAccount()}
                    {drawPO()}
                </div>

                <div style={{ flex: "1 1 0", minWidth: "200px" }}>
                    {drawVia()}
                    {drawCalculatedTotals()}
                </div>

                <div style={{ flex: "1 1 0", minWidth: "200px" }}>
                    {drawGroup()}
                </div>

                <div style={{ flex: "1 1 0", minWidth: "200px" }}>
                    {drawImage()}
                </div>
            </div>
            {drawNote()}
        </div>
    )
}